import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CalendarIcon } from 'lucide-react';
export function AppointmentCTA() {
  return <section className="py-32 bg-schwarz relative overflow-hidden" data-id="element-18">
      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-19">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-5xl md:text-6xl font-poppins font-bold text-weiss mb-8 uppercase tracking-tight" data-id="element-20">
          Vereinbaren Sie Ihren Termin
        </motion.h2>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-xl text-gray-light font-lora mb-12 max-w-2xl mx-auto" data-id="element-21">
          Unser Team ist für alle Patienten und Patientinnen, auch aus Fürth und
          Erlangen, mit schnellen Terminen da.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="flex flex-col sm:flex-row items-center justify-center gap-8" data-id="element-22">
          <Link to="/kontakt" data-id="element-23">
            <button className="btn-gold-hover flex items-center space-x-3 border-2 border-gold text-gold px-10 py-5 font-poppins font-bold uppercase tracking-widest" data-id="element-24">
              <CalendarIcon className="w-5 h-5" data-id="element-25" />
              <span data-id="element-26">Termin vereinbaren</span>
            </button>
          </Link>

          <span className="text-gray-medium font-lora italic" data-id="element-27">oder</span>

          <a href="tel:091156836360" className="text-2xl text-weiss hover:text-gold transition-colors font-poppins font-bold" data-id="element-28">
            0911-56 83 63 60
          </a>
        </motion.div>
      </div>
    </section>;
}